import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";

declare global {
    interface Window {
        grecaptcha: any;
    }
}

const DELETE_ACCOUNT_TEMPLATE_ID = "template_o5sp8ud";

const DeleteAccount = () => {
    const [formData, setFormData] = useState({
        email: "",
        club_name: "",
        full_name: "",
        date_of_birth: "",
        removal_reason: "",
        to_name: "Grassroots360 Team",
    });
    const [consentGiven, setConsentGiven] = useState(false);
    const [isSent, setIsSent] = useState(false);
    const [sendFailed, setSendFailed] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setSendFailed(false);

        if (!window.grecaptcha) {
            console.error("reCAPTCHA is not loaded");
            setSendFailed(true);
            return;
        }

        window.grecaptcha.enterprise.execute("6LeHrJ8qAAAAAHVZqFtPJvJxTrgwfbPlsyeqgPpk", { action: "submit" })
            .then((token: string) => {
                const formWithToken = {
                    ...formData,
                    consent_given: consentGiven ? "Yes" : "No",
                    "g-recaptcha-response": token,
                };

                emailjs.send(
                    "service_ausb2km",
                    DELETE_ACCOUNT_TEMPLATE_ID,
                    formWithToken,
                    "81J8oXgS-t2Y8vbL2"
                ).then(
                    (response) => {
                        console.log("SUCCESS!", response.status, response.text);
                        setIsSent(true);
                    },
                    (error) => {
                        console.error("FAILED...", error);
                        setSendFailed(true);
                    }
                );
            })
            .catch((error: any) => {
                console.error("reCAPTCHA failed", error);
                setSendFailed(true);
            });
    };

    return (
        <article className="container">
            <div className="page mb-2">
                <h2>Request Data Deletion</h2>
                <p>
                    To request the deletion of all data Grassroots360 holds about you, please complete the form below.
                    We will process your request and contact you to confirm once it has been completed.
                </p>

                <div className="contact-form-content">
                    <form onSubmit={handleSubmit}>
                        <div>
                            <label>Email Address:</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Your Email Address"
                                required
                            />
                        </div>
                        <div>
                            <label>Club Name:</label>
                            <input
                                type="text"
                                name="club_name"
                                value={formData.club_name}
                                onChange={handleChange}
                                placeholder="Your Club Name"
                                required
                            />
                        </div>
                        <div>
                            <label>Full Name:</label>
                            <input
                                type="text"
                                name="full_name"
                                value={formData.full_name}
                                onChange={handleChange}
                                placeholder="Your Full Name"
                                required
                            />
                        </div>
                        <div>
                            <label>Date of Birth:</label>
                            <input
                                type="date"
                                name="date_of_birth"
                                value={formData.date_of_birth}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div>
                            <label>Reason for Removal:</label>
                            <textarea
                                name="removal_reason"
                                value={formData.removal_reason}
                                onChange={handleChange}
                                placeholder="Please tell us why you would like your data removed"
                                required
                            />
                        </div>
                        <div className="consent-checkbox">
                            <label>
                                <input
                                    type="checkbox"
                                    name="consent_given"
                                    checked={consentGiven}
                                    onChange={(e) => setConsentGiven(e.target.checked)}
                                    required
                                />
                                I understand that my data will be removed within 3 days and will be
                                unrecoverable after this time.
                            </label>
                        </div>
                        <button type="submit">
                            <span className="material-symbols-outlined">delete</span> Submit Request
                        </button>

                        {isSent && (
                            <p className="success-message">
                                <span className="material-symbols-outlined">mark_email_read</span>
                                Your deletion request has been received. We will be in touch shortly.
                            </p>
                        )}

                        {sendFailed && (
                            <p className="error-message">
                                <span className="material-symbols-outlined">error</span>
                                Sorry, your request could not be submitted right now. Please email your deletion
                                request to <a href="mailto:privacy@grassroots360.co.uk">privacy@grassroots360.co.uk</a> instead.
                            </p>
                        )}
                    </form>
                </div>
            </div>
        </article>
    );
};

export default DeleteAccount;
